import { useContext } from 'react';
import { DrawerContext } from '@/contexts/drawer/helpers';

const useDrawer = () => useContext(DrawerContext);

export default useDrawer;
